import Button from '../../../../../ui/Button/BlockButton';
import { useTheme } from '../../../../../../hooks/useTheme';
import styles from '../Fetch.module.css';
import { FETCH_WELCOME_URL } from '../constants';
import { FetchOfferBar } from './FetchOfferBar';
import { FetchLogo } from './FetchLogo';

const HEADING = 'Your price is ready!';
const CTA_LABEL = 'Customize Your Coverage';

interface FetchConfirmationInlineProps {
  isMobile?: boolean;
  buyUrl?: string;
}

function ConfirmCheck() {
  return (
    <svg
      className={styles.confirmCheck}
      viewBox="0 0 80 80"
      role="img"
      aria-label="Success"
    >
      <circle
        cx="40"
        cy="40"
        r="37"
        fill="none"
        stroke="#40779c"
        strokeWidth="3"
      />
      <path
        d="M24 41l11 11 21-23"
        fill="none"
        stroke="#40779c"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function FetchConfirmationInline({
  isMobile,
  buyUrl,
}: FetchConfirmationInlineProps) {
  const theme = useTheme();
  // buyUrl is set on every normal path; this only covers a missing quote, and
  // it stays attributed rather than dropping to an unattributed fetchpet.com link.
  const ctaUrl = buyUrl ?? FETCH_WELCOME_URL;
  const bodyFont = theme.bodytextDefaultNone?.fontFamily;
  const headerFont = theme.headersMediumNone?.fontFamily;

  if (isMobile) {
    return (
      <div className={styles.confirmMobile} style={{ fontFamily: bodyFont }}>
        <FetchLogo />
        <ConfirmCheck />
        <h2
          className={styles.confirmHeadingMobile}
          style={{ fontFamily: headerFont }}
        >
          {HEADING}
        </h2>
        <div className={styles.confirmActionsMobile}>
          <Button href={ctaUrl} big>
            {CTA_LABEL}
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.confirmCard} style={{ fontFamily: bodyFont }}>
      <FetchOfferBar />
      <div className={styles.confirmBody}>
        <div className={styles.confirmRow}>
          <div className={styles.confirmHeadline}>
            <ConfirmCheck />
            <h2
              className={styles.confirmHeading}
              style={{ fontFamily: headerFont }}
            >
              {HEADING}
            </h2>
          </div>
          <FetchLogo />
        </div>

        <div className={styles.confirmActions}>
          <Button href={ctaUrl}>{CTA_LABEL}</Button>
        </div>
      </div>
    </div>
  );
}
